export default __webpack_public_path__ + "static/media/date.61aff764.svg";